"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { publicEnv } from "@/lib/env";
import type { ConsentState } from "@/lib/consent";

/**
 * Lädt die Messung – aber NUR, wenn eine Einwilligung für Statistik oder
 * Marketing vorliegt. Auf jeder Seite, weil die Komponente im Cookie-Banner
 * des Root-Layouts steckt.
 *
 * GENAU EIN WEG: der Tag Manager.
 *
 * Bis zum 22.09.2026 lief zusätzlich gtag.js mit derselben Property. Der
 * Container GTM-KG4X89GZ enthält aber ein Google-Tag mit ebendieser ID und
 * dazu GA4-Ereignis-Tags für `generate_lead` und `phone_click`. Beim
 * Seitenaufruf blieb das folgenlos, weil gtag.js dieselbe Mess-ID nur einmal
 * einrichtet. Bei Ereignissen nicht: Eine abgeschickte Anfrage löste den Tag
 * im Container aus UND einen zweiten Aufruf über `send_to` – jede Anfrage
 * zählte doppelt. Für eine Conversion, auf die Google Ads bietet, ist das der
 * teuerste denkbare Fehler.
 *
 * gtag.js bleibt als Rückfallebene: Wer nur NEXT_PUBLIC_GA_ID setzt und
 * keinen Container betreibt, misst weiterhin.
 */
/**
 * Seiten mit geheimem Link (Fragebogen, Upload, Terminzusage): keine Messung.
 * GA/GTM bekämen sonst die volle Adresse samt Zugangs-Token.
 */
const PRIVATE_PATHS = ["/briefing", "/unterlagen", "/termine"];

export function Analytics({ consent }: { consent: ConsentState | null }) {
  const pathname = usePathname();
  const allowed = !!consent && (consent.statistics || consent.marketing);
  if (!allowed || PRIVATE_PATHS.some((p) => pathname.startsWith(p))) return null;

  const { gtmId, gaId } = publicEnv;

  return (
    <>
      {gtmId && (
        <>
        <Script id="gtm-loader" strategy="afterInteractive">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`}
        </Script>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          />
        </noscript>
        </>
      )}
      {!gtmId && gaId && (
        <>
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
          strategy="afterInteractive"
        />
        <Script id="ga-loader" strategy="afterInteractive">
          {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`}
        </Script>
        </>
      )}
    </>
  );
}
